import React, { memo } from 'react'
import { SpotBiddingConfigsHeader } from 'apps/spot-quote-control-panel/components/SpotBiddingConfigsHeader'
import { Table, TableBody } from 'transfix-ui'
import { ISpotBiddingConfig, ISpotBiddingConfigsParams } from '../types/spotBiddingConfig'
import { SpotBiddingConfigsTableRow } from './SpotBiddingConfigsTableRow'

interface ISpotBiddingConfigsTableProps {
  spotBiddingConfigs: ISpotBiddingConfig[]
  totalCount: number
  params: ISpotBiddingConfigsParams
  openEditModal: (config: ISpotBiddingConfig) => void
  openDeleteModal: (config: ISpotBiddingConfig) => void
}

export const SpotBiddingConfigsTable = memo<ISpotBiddingConfigsTableProps>(
  ({ openDeleteModal, openEditModal, spotBiddingConfigs }) => {
    if (spotBiddingConfigs.length === 0) {
      return (
        <div className='tc mv2'>
          <h3>No active control panels found</h3>
        </div>
      )
    }
    return (
      <Table>
        <SpotBiddingConfigsHeader />
        <TableBody dataTest='spot-bidding-configs-table'>
          {spotBiddingConfigs.map(config => (
            <SpotBiddingConfigsTableRow
              key={config.id}
              spotBiddingConfig={config}
              openEditModal={openEditModal}
              openDeleteModal={openDeleteModal}
            />
          ))}
        </TableBody>
      </Table>
    )
  }
)
